import React, { useEffect } from 'react';

interface ModalProps {
  onClose: () => void;
  size?: 'md' | 'lg' | 'xl' | '4xl';
  children: React.ReactNode;
}

const sizeClasses: Record<string, string> = {
  md: 'max-w-md',
  lg: 'max-w-lg',
  xl: 'max-w-xl',
  '4xl': 'max-w-4xl',
};

const Modal: React.FC<ModalProps> = ({ onClose, size = 'md', children }) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  // 7.3 mobile: below `md` a modal becomes a FULL-SCREEN SHEET — no outer padding, no
  // rounded corners, no border, and it owns the whole dynamic viewport. Centering a
  // capped-height dialog inside a 390px screen wastes ~20% of the space on backdrop and
  // makes dense content (AgentDetailModal: 5 tabs, charts, tables) unusable. `dvh` (not
  // `vh`) because mobile browser chrome shrinks the visual viewport on scroll.
  // Safe-area padding keeps content clear of the notch and home indicator.
  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-stretch justify-center
                 z-50 p-0 md:items-center md:p-4"
      onClick={onClose}
    >
      <div
        className={`bg-slate-800 border-slate-700 w-full flex flex-col shadow-2xl overflow-hidden
                    h-[100dvh] rounded-none border-0
                    pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]
                    md:h-auto md:max-h-[90dvh] md:rounded-xl md:border md:pt-0 md:pb-0
                    ${sizeClasses[size]}`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
